import SiteHeader from "../components/SiteHeader.jsx";
import SiteFooter from "../components/SiteFooter.jsx";

const decoratedLink = (uri, label) => {
    return <a href={uri} className="underline hover:font-semibold">{label}</a>
}

const TeamGroup = ({title, members, columns = false}) =>
    <div className="rounded-2xl border border-slate-200/90 bg-gradient-to-b from-white to-slate-50/70 p-5 shadow-[0_18px_45px_-40px_rgba(15,23,42,0.75)]">
        <h3 className="text-center text-sm font-semibold uppercase tracking-wide text-slate-500 mb-4">{title}</h3>
        <ul className={columns ? "grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-2 text-center" : "space-y-2 text-center"}>
            {members.map((m, i) => <li key={i}>{m}</li>)}
        </ul>
    </div>

export default () => <div className="flex flex-col min-h-screen bg-slate-50">
    <SiteHeader/>

    <div className="max-w-4xl w-full mx-auto px-4 py-10 flex-1 text-center">

        <h1 className="text-3xl font-semibold mb-4 text-blue-800">The OpenProt Team</h1>
        <p className="text-base mb-2">
            OpenProt is a collaboration of the {decoratedLink("https://www.roucoulab.com/en/index.html", "Roucou")} and {decoratedLink("https://www.researchgate.net/lab/Marie-Brunet-Lab", "Brunet")} labs
        </p>
        <p className="text-base mb-8">
            from University of Sherbrooke in Canada
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            <TeamGroup
                title="Leadership"
                members={[
                    decoratedLink("mailto:xavier.roucou@usherbrooke.ca", "Xavier Roucou"),
                    decoratedLink("mailto:marie.brunet@usherbrooke.ca", "Marie Brunet"),
                ]}
            />
            <TeamGroup
                title="Informatics"
                members={[
                    decoratedLink("mailto:sebastien.leblanc5@usherbrooke.ca", "Sebastien Leblanc"),
                    decoratedLink("mailto:Francis.Bourassa@usherbrooke.ca", "Francis Bourassa"),
                    decoratedLink("mailto:jean-francois.lucier@usherbrooke.ca", "Jean-Francois Lucier"),
                    decoratedLink("mailto:maxime.levesque@gmail.com", "Maxime Lévesque"),
                ]}
            />
        </div>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-3 gap-6">
            <TeamGroup
                title="Université de Sherbrooke, Quebec, Canada"
                members={[
                    decoratedLink("mailto:xavier.roucou@usherbrooke.ca", "Xavier Roucou"),
                    decoratedLink("mailto:marie.brunet@usherbrooke.ca", "Marie Brunet"),
                    decoratedLink("https://bioinfo-scottgroup.med.usherbrooke.ca/team/", "Michelle Scott")
                ]}
            />
            <TeamGroup
                title="RiboCrypt, University of Oslo, Norway"
                members={[
                    decoratedLink("mailto:eivind.valen@ibv.uio.no", "Eivind Valen"),
                ]}
            />
            <TeamGroup
                title="ORBL, MIT, USA"
                members={[
                    decoratedLink("mailto:iljungr@csail.mit.edu", "Irwin Jungreis"),
                    decoratedLink("mailto:manoli@mit.edu", "Manolis Kellis"),
                ]}
            />
        </div>

        <div className="mt-10">
            <TeamGroup
                title="Graduate Students"
                columns
                members={[
                    "Félix-Antoine Trifiro",
                    "Valeriia Vasylieva",
                    "Nicolas Provencher",
                    "Fériel Yala",
                ]}
            />
        </div>
    </div>
    <SiteFooter/>
</div>